import React, { useEffect, useState } from "react";
import { Label, RequiredRule } from 'devextreme-react/form';
import { CheckBox, DateBox, NumberBox, TextBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";

//CUMPLEAÑOS
const EXT_IntegranteAutorizar = (props) => {

  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_LeerPorDNISinPassword, function_ABM_EEX_Clientes_InsertarBasico } } = require('neftis7_apicaller');
  const { VEN_Reservas_Cabecera: { function_VEN_Reservas_Cabecera_LeerNombresAgasajados } } = require('neftis7_apicaller');
  const { VEN_Reservas_Detalle: { function_VEN_Reservas_Detalle_Leer } } = require('neftis7_apicaller');
  const { VEN_Reservas_Integrantes: { function_VEN_Reservas_Integrantes_Insertar, function_VEN_Reservas_Integrantes_Generar_JSON } } = require('neftis7_apicaller');
  const [idReserva, setIdReserva] = useState(0);
  const [idItem, setIdItem] = useState(0);
  const [idCliente, setIdCliente] = useState(0);
  const [cuit, setCUIT] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState(new Date());

  const [idClienteAutorizado, setIdClienteAutorizado] = useState(0);
  const [cuitAutorizado, setCUITAutorizado] = useState("");
  const [nombreAutorizado, setNombreAutorizado] = useState("");
  const [apellidoAutorizado, setApellidoAutorizado] = useState("");
  const [fechaNacimientoAutorizado, setFechaNacimientoAutorizado] = useState(new Date());

  const [telefono, setTelefono] = useState("");
  const [eMail, setEMail] = useState("");
  const [calle, setCalle] = useState("");
  const [numero, setNumero] = useState("");
  const [piso, setPiso] = useState("");
  const [depto, setDepto] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [puedeGuardar, setPuedeGuardar] = useState(true);
  const [readOnlyCliente, setReadOnlyCliente] = useState(false);
  const [readOnlyClienteAutorizado, setReadOnlyClienteAutorizado] = useState(false);
  const [titulo, setTitulo] = useState("AUTORIZACIÓN PARA EL CUMPLE");
  const linkTerminos = "https://neftis.com.ar/Terminos/" + props.CodigoCompania + "/Terminos.htm"
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const handleIdClienteOnValueChanged = (e) => {
    setIdCliente(e.value)
  }

  const handleCuitOnValueChanged = (e) => {
    setCUIT(e.value)
  }

  const handleCuitonFocusOut = async (e) => {
    const resultClientes = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuit)

    if (resultClientes && resultClientes.data && resultClientes.data.length > 0) {
      setIdCliente(resultClientes.data[0].IdCliente);
      setNombre(resultClientes.data[0].Nombre);
      setApellido(resultClientes.data[0].Apellido);
      setTelefono(resultClientes.data[0].Telefonos);
      setEMail(resultClientes.data[0].Emails);
      setFechaNacimiento(resultClientes.data[0].FechaNacimiento);
    }
    else {
      setIdCliente(0);
      setNombre("");
      setApellido("");
      setTelefono("");
      setEMail("");
      setFechaNacimiento(new Date());
    }
  }

  const handleNombreOnValueChanged = (e) => {
    setNombre(e.value)
  }

  const handleApellidoOnValueChanged = (e) => {
    setApellido(e.value)
  }

  const handleFechaNacimientoOnValueChanged = (e) => {
    setFechaNacimiento(e.value)
  }

  const handleIdClienteAutorizadoOnValueChanged = (e) => {
    setIdClienteAutorizado(e.value)
  }

  const handleCuitAutorizadoOnValueChanged = (e) => {
    setCUITAutorizado(e.value)
  }

  const handleCuitAutorizadoonFocusOut = async (e) => {

    const resultClientes = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuitAutorizado)

    if (resultClientes && resultClientes.data && resultClientes.data.length > 0) {
      setIdClienteAutorizado(resultClientes.data[0].IdCliente);
      setNombreAutorizado(resultClientes.data[0].Nombre);
      setApellidoAutorizado(resultClientes.data[0].Apellido);
      setFechaNacimientoAutorizado(resultClientes.data[0].FechaNacimiento);
    }
    else {
      setIdClienteAutorizado(0);
      setNombreAutorizado("");
      setApellidoAutorizado("");
      setFechaNacimientoAutorizado(new Date());
    }
  }

  const handleNombreAutorizadoOnValueChanged = (e) => {
    setNombreAutorizado(e.value)
  }

  const handleApellidoAutorizadoOnValueChanged = (e) => {
    setApellidoAutorizado(e.value)
  }

  const handleFechaNacimientoAutorizadoOnValueChanged = (e) => {
    setFechaNacimientoAutorizado(e.value)
  }

  const handleTelefonoOnValueChanged = (e) => {
    setTelefono(e.value)
  }

  const handleEMailOnValueChanged = (e) => {
    setEMail(e.value)
  }

  const handleCalleOnValueChanged = (e) => {
    setCalle(e.value)
  }

  const handleNumeroOnValueChanged = (e) => {
    setNumero(e.value)
  }

  const handlePisoOnValueChanged = (e) => {
    setPiso(e.value)
  }

  const handleDeptoOnValueChanged = (e) => {
    setDepto(e.value)
  }

  const handleCodigoPostalOnValueChanged = (e) => {
    setCodigoPostal(e.value)
  }

  const onClickGuardar = () => {

    if (!termsAccepted) {
      alert("Debe aceptar los términos y condiciones.");
      return;
    }

    if (!cuit || !nombre || !apellido || !fechaNacimiento || !telefono || !eMail || !nombreAutorizado || !apellidoAutorizado || !fechaNacimientoAutorizado || !cuitAutorizado) {
      alert("Todos los campos son obligatorios.");
      return;
    }

    let idClientePorRegistrar = idCliente
    let idClienteAutorizadoPorRegistrar = idClienteAutorizado

    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      const guardar = async () => {
        if (idCliente < 1) {
          const resultIdClientePorRegistrar = await function_ABM_EEX_Clientes_InsertarBasico(apellido, nombre, cuit, await FormateoFechaPara_yyyyMMdd(fechaNacimiento), cuit, eMail, telefono)
          idClientePorRegistrar = resultIdClientePorRegistrar.data.codigoGenerado;
        }

        if (idClienteAutorizado < 1) {
          const resultIdClienteAutorizadoPorRegistrar = await function_ABM_EEX_Clientes_InsertarBasico(apellidoAutorizado, nombreAutorizado, cuitAutorizado, await FormateoFechaPara_yyyyMMdd(fechaNacimientoAutorizado), cuitAutorizado, eMail, telefono)
          idClienteAutorizadoPorRegistrar = resultIdClienteAutorizadoPorRegistrar.data.codigoGenerado;
        }

        if (idClientePorRegistrar > 0 && idClienteAutorizadoPorRegistrar > 0) {

          const Integrante = await function_VEN_Reservas_Integrantes_Generar_JSON(idItem, localStorage.getItem("CodigoCompania"), idClienteAutorizadoPorRegistrar, idClientePorRegistrar)
          await function_VEN_Reservas_Integrantes_Insertar(Integrante)
        }
      }

      guardar();

      setCUIT("")
      setIdCliente(0);
      setNombre("");
      setApellido("");
      setTelefono("");
      setEMail("");
      setFechaNacimiento("");
      setCUITAutorizado("")
      setIdClienteAutorizado(0);
      setNombreAutorizado("");
      setApellidoAutorizado("");
      setFechaNacimientoAutorizado("");

      alert(nombre + ", has registrado correctamente a " + nombreAutorizado + "!.");
    } catch (error) {
      alert(nombre + ", hubo problemas en el registro.");
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  useEffect(() => {
    localStorage.setItem("CodigoCompania", props.CodigoCompania);
    localStorage.setItem("CodigoEmpresa", props.CodigoEmpresa);
    localStorage.setItem("CodigoPlanta", props.CodigoPlanta);
    setIdReserva(props.IdReserva)
    setIdItem(props.IdItem)

    const leerDatos = async () => {
      const item = await function_VEN_Reservas_Detalle_Leer(props.IdReserva, props.IdItem)

      if (item && item.data && item.data.length > 0) {
        const agasa = await function_VEN_Reservas_Cabecera_LeerNombresAgasajados(props.IdReserva)
        let agasajados = agasa.data

        if (agasajados != '') {
          setTitulo(titulo + ' DE ' + agasajados.toUpperCase())
        }
      } else {
        setPuedeGuardar(false)
        alert("Este cumple ya no está disponible.");
      }
    }
    leerDatos();
  }, []);

  useEffect(() => {
    if (idCliente > 0) {
      setReadOnlyCliente(true)
    }
    else {
      setReadOnlyCliente(false)
    }
  }, [idCliente]);

  useEffect(() => {
    if (idClienteAutorizado > 0) {
      setReadOnlyClienteAutorizado(true)
    }
    else {
      setReadOnlyClienteAutorizado(false)
    }
  }, [idClienteAutorizado]);

  return (
    <table width={'100%'} >
      <tbody>
        <tr>
          <td style={{ margin: '10px', padding: '5px', textAlign: 'center', fontSize: '30px' }} colSpan={2}>
            {titulo}
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px', textAlign: 'left', fontSize: '14px' }} colSpan={2}>
            RESPONSABLE
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <NumberBox
              label="Código"
              value={idCliente}
              onValueChanged={handleIdClienteOnValueChanged}
              visible={false} />
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <NumberBox
              label="D.N.I."
              value={cuit}
              onValueChanged={handleCuitOnValueChanged}
              onFocusOut={handleCuitonFocusOut}>
              <Label text="D.N.I." />
              <RequiredRule message="Indicar el D.N.I. es obligatorio." />
            </NumberBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Nombre"
              value={nombre}
              onValueChanged={handleNombreOnValueChanged}
              readOnly={readOnlyCliente}>
              <Label text="Nombre" />
              <RequiredRule message="Indicar el Nombre es obligatorio." />
            </TextBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Apellido"
              value={apellido}
              onValueChanged={handleApellidoOnValueChanged}
              readOnly={readOnlyCliente}>
              <Label text="Apellido" />
              <RequiredRule message="Indicar el Apellido es obligatorio." />
            </TextBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Teléfono"
              value={telefono}
              onValueChanged={handleTelefonoOnValueChanged}
              readOnly={readOnlyCliente}>
              <Label text="Teléfono" />
              <RequiredRule message="Indicar el Teléfono es obligatorio." />
            </TextBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="E-Mail"
              value={eMail}
              onValueChanged={handleEMailOnValueChanged}
              readOnly={readOnlyCliente}>
              <Label text="E-Mail" />
              <RequiredRule message="Indicar el E-Mail es obligatorio." />
            </TextBox>
          </td>
        </tr>
        <tr>
          <td width={150}>
            Fecha de Nacimiento
          </td>
          <td style={{ margin: '10px', padding: '5px' }}>
            <DateBox
              displayFormat="dd/MM/yyyy"
              value={fechaNacimiento}
              onValueChanged={handleFechaNacimientoOnValueChanged}
              width={120}
              readOnly={readOnlyCliente}>
            </DateBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>

            <table width={'100%'} >
              <tbody>
                <tr>
                  <td style={{ margin: '10px', padding: '5px' }} colSpan={4}>
                    <TextBox
                      label="Calle"
                      value={calle}
                      onValueChanged={handleCalleOnValueChanged}
                      visible={false}
                      readOnly={readOnlyCliente}>
                    </TextBox>
                  </td>
                </tr>

                <tr>
                  <td style={{ margin: '10px', padding: '5px' }}>
                    <NumberBox
                      label="Altura"
                      value={numero}
                      onValueChanged={handleNumeroOnValueChanged}
                      visible={false}
                      readOnly={readOnlyCliente}>
                    </NumberBox>
                  </td>

                  <td style={{ margin: '10px', padding: '5px' }}>
                    <TextBox
                      label="Piso"
                      value={piso}
                      onValueChanged={handlePisoOnValueChanged}
                      visible={false}
                      readOnly={readOnlyCliente}>
                    </TextBox>
                  </td>

                  <td style={{ margin: '10px', padding: '5px' }}>
                    <TextBox
                      label="Depto"
                      value={depto}
                      onValueChanged={handleDeptoOnValueChanged}
                      visible={false}
                      readOnly={readOnlyCliente}>
                    </TextBox>
                  </td>

                  <td style={{ margin: '10px', padding: '5px' }}>
                    <TextBox
                      label="Código Postal"
                      value={codigoPostal}
                      onValueChanged={handleCodigoPostalOnValueChanged}
                      visible={false}
                      readOnly={readOnlyCliente}>
                    </TextBox>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px', textAlign: 'left', fontSize: '14px' }} colSpan={2}>
            AUTORIZADO
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <NumberBox
              label="Código"
              value={idClienteAutorizado}
              onValueChanged={handleIdClienteAutorizadoOnValueChanged}
              visible={false} />
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <NumberBox
              label="D.N.I."
              value={cuitAutorizado}
              onValueChanged={handleCuitAutorizadoOnValueChanged}
              onFocusOut={handleCuitAutorizadoonFocusOut}>
              <Label text="D.N.I." />
              <RequiredRule message="Indicar el D.N.I. es obligatorio." />
            </NumberBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Nombre"
              value={nombreAutorizado}
              onValueChanged={handleNombreAutorizadoOnValueChanged}
              readOnly={readOnlyClienteAutorizado}>
              <Label text="Nombre" />
              <RequiredRule message="Indicar el Nombre es obligatorio." />
            </TextBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <TextBox
              label="Apellido"
              value={apellidoAutorizado}
              onValueChanged={handleApellidoAutorizadoOnValueChanged}
              readOnly={readOnlyClienteAutorizado}>
              <Label text="Apellido" />
              <RequiredRule message="Indicar el Apellido es obligatorio." />
            </TextBox>
          </td>
        </tr>
        <tr>
          <td width={150}>
            Fecha de Nacimiento
          </td>
          <td style={{ margin: '10px', padding: '5px' }}>
            <DateBox
              displayFormat="dd/MM/yyyy"
              value={fechaNacimientoAutorizado}
              onValueChanged={handleFechaNacimientoAutorizadoOnValueChanged}
              width={120}
              readOnly={readOnlyClienteAutorizado}>
            </DateBox>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <div style={{
              background: '#f2b6b6',
              color: 'darkred',
              padding: '8px',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <CheckBox
                text=""
                value={termsAccepted}
                onValueChanged={(e) => setTermsAccepted(e.value)}
              />
              <a href={linkTerminos} target="_blank" rel="noopener noreferrer" >
                ACEPTO LOS TÉRMINOS y CONDICIONES
              </a>
            </div>

            <div style={{ margin: '10px', padding: '5px' }}>
              <iframe
                src={linkTerminos}
                width="100%"
                height="500px"
                title="Términos y Condiciones"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
            <LVButtonAccion
              Disabled={cierreEnProceso} Texto="GUARDAR" Ancho={'100%'} onClick={onClickGuardar} visible={puedeGuardar} />
          </td>
        </tr>
      </tbody>
    </table>
  );

}

export default EXT_IntegranteAutorizar;